import React from "react";
import BoiReactMarkdown from "../boi-markdown/boi-markdown";
import { Container } from "../forms/controls";

type StyledListProps = {
    children: string,
    listType?: string;
    className?: string;
};

const parseListType = (listType = ""): string => {
    return (
        {
            "check": "check-list",
            "negative": "negative-list",
            "alpha-upper": "u-list-alpha-upper",
            "alpha-lower": "u-list-alpha-lower",
            "roman-upper": "u-list-roman-upper",
            "roman-lower": "u-list-roman-lower"
        } as { [key: string]: string }
    )[listType] || parseListType("check");
};

const StyledList = ({
    children,
    listType,
    className = ""
}: StyledListProps) => (
    <Container cssClass={parseListType(listType) + (className && " " + className)} >
        <BoiReactMarkdown>{children}</BoiReactMarkdown>
    </Container>
);

export { StyledList };
